import { render, staticRenderFns } from "./BajaPorArchivo.vue?vue&type=template&id=13ee5af2&scoped=true"
import script from "./BajaPorArchivo.vue?vue&type=script&lang=js"
export * from "./BajaPorArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee5af2",
  null
  
)

export default component.exports